export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "compliance_threshold": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["seuil ", _interpolate(_named("threshold")), " %"])},
        "above_threshold": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["✓ Au-dessus du seuil — gains débloqués"])},
        "below_threshold": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["✕ En dessous du seuil — gains bloqués"])}
      },
      "en": {
        "compliance_threshold": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("threshold")), " % target"])},
        "above_threshold": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["✓ Above target — rewards unlocked"])},
        "below_threshold": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["✕ Below target — rewards locked"])}
      }
    }
  })
}
